import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Team } from '@b3networks/api/auth';
import { DirectoryMember } from '@b3networks/api/directory';
import { DestroySubscriberComponent, ZoomPanContainerComponent } from '@b3networks/shared/common';
import { InfoMemberComponent } from './info-member/info-member.component';

export interface OrgChartData extends Team {
  membersDirectory: DirectoryMember[];
}

@Component({
  selector: 'b3n-org-chart',
  templateUrl: './org-chart.component.html',
  styleUrls: ['./org-chart.component.scss'],
  standalone: true,
  imports: [CommonModule, ZoomPanContainerComponent, MatProgressSpinnerModule, MatIconModule]
})
export class OrgChartComponent extends DestroySubscriberComponent implements OnChanges {
  @Input() teamsData: OrgChartData[];
  @Input() isLoading: boolean;
  @ViewChild('containerRef') containerRef: ElementRef<HTMLElement>;
  @ViewChild('chartRef') chartRef: ElementRef<HTMLElement>;

  scaleInit: number = 0;

  constructor(private dialog: MatDialog) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['isLoading'].currentValue) this.setChartToCenter();
  }

  setChartToCenter(): void {
    setTimeout(() => {
      const containerElm = this.containerRef?.nativeElement;
      const chartElm = this.chartRef?.nativeElement;
      this.scaleInit = containerElm?.offsetWidth / (chartElm?.offsetWidth + 300);
    });
  }

  openDialogInfoMember(member: DirectoryMember) {
    this.dialog
      .open(InfoMemberComponent, {
        data: { member }
      })
      .afterClosed()
      .subscribe();
  }
}
